
import DetailMixin from '@/mixins/DetailMixin';

export default {
    mixins: [
        DetailMixin,
    ],

    props: {
        person: Object,
        asDriver: Boolean,
    },

    computed: {
        readonly() {
            // Hack to override computed property in mixin with Boolean pseudo-prop
            return this.$attrs.readonly === true || this.$attrs.readonly === '';
        },
    },

    watch: {
        person() {
            this.loadItem();
        },
    },

    methods: {
        loadItem() {
            if (!this.person) {
                this.editItem = $.getNu(this.collName);
            } else {
                this.item = this.person;

                if (this.readonly) {
                    this.editItem = this.item;
                } else {
                    this.initEdit();
                }
            }

            return true;
        },
    },
};
